import React, { useEffect, useState } from "react";
import "./Contactus.css";
import Select from "react-select";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import DatePicker from "react-datepicker";
import ContactModal from "./ContactModal/ContactModal";

// import "react-datepicker/dist/react-datepicker.css";
import InputGroup from "react-bootstrap/InputGroup";
import { Link, useNavigate } from "react-router-dom";

import { useContext } from "react";
import { Context } from "../../../utils/context";
import Dark_Blue_Btn from "../../common_components/common_btn/dark_blue_btn/Dark_Blue_Btn";
import Common_Title from "../../common_components/common_title/Common_Title";
const Contactus = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const options = [];

  const navigate = useNavigate();
  const { getData, postData, imageUrl } = useContext(Context);

  const [cities, setCities] = useState();

  const getCities = async () => {
    const res = await getData("/without-login/master/all-cities");
    if (res?.success) {
      const mergedOptions = [
        ...options,
        ...res.data.map((city) => ({ value: city?.id, label: city?.name })),
      ];

      setCities(mergedOptions);
    }
  };

  const [modalShow, setModalShow] = useState(false);

  const [nameErr, setNameErr] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [mobileErr, setMobileErr] = useState("");
  const [livingErr, setLivingErr] = useState("");
  const [messageErr, setMessageErr] = useState("");

  const handleValidation = async () => {
    var username = document.getElementById("username").value;
    var email = document.getElementById("email").value;
    var mobile = document.getElementById("mobile").value;
    var message = document.getElementById("message").value;

    // Initialize an array to store error messages
    var errors = [];

    if (username?.trim() === "") {
      setNameErr("Fullname is required");
      errors.push("Username is required");
    } else if (!/^[a-zA-Z ]+$/.test(username)) {
      setNameErr("Username should contain only letters and spaces");
      errors.push("Username should contain only letters and spaces");
    }

    if (email?.trim() === "") {
      setEmailErr("Email is required");
      errors.push("Email is required");
    } else if (
      !/^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z0-9_\-\.]+)\.\2)([A-Za-z0-9_\-\.]+\.)+([A-Za-z]{2,4})$/.test(
        email,
      )
    ) {
      setEmailErr("Email is not valid");
      errors.push("Email is not valid");
    }

    if (mobile?.trim() === "") {
      setMobileErr("Contact Number is required");
      errors.push("Contact Number is required");
    } else if (!/^\d{10}$/.test(mobile)) {
      setMobileErr("Contact Number should be a 10-digit number");
      errors.push("Contact Number should be a 10-digit number");
    }

    if (selectedOption === null) {
      setLivingErr("Living City is required");
      errors.push("Living City is required");
    }

    if (message?.trim() === "") {
      setMessageErr("Message is required");
      errors.push("Message is required");
    }

    if (errors.length === 0) {
      const data = {
        name: username,
        email: email,
        mobile: "91" + mobile,
        remark: message,
        city_id: selectedOption?.value,
      };

      const res = await postData("/without-login/contact-us", data);

      if (res?.success) {
        setModalShow(true);

        setTimeout(() => {
          navigate("/");
          setModalShow(false);
        }, 4000);
      } else {
      }
    }
  };

  useEffect(() => {
    getCities();
  }, []);

  return (
    <>
      <section className="requiter-signup-form contact_us">
        <div className="container">
          <div className="row">
            <div className="title_div">
              <Common_Title title="Contact Us " subTitle="for any Support" />
              {/* <div className="  heading-holder mt-3 mb-4">
                <h4>Contact Us for any Support</h4>
              </div> */}
            </div>
            <div className="col-xxl-9 col-xl-9 col-lg-11 col-md-12 mx-auto ">
              <div className="form-contact-main1 ">
                <div className="row contact_form_card">
                  <div className="col-xxl-7 col-xl-7 col-lg-7 ">
                    <Form className="form_contact mt-3">
                      <Row className="mb-3">
                        <Form.Group as={Col} controlId="formGridfirstname">
                          <Form.Label>
                            Full Name<span className="red-star">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Full Name"
                            id="username"
                            onKeyDown={(event) => {
                              if (!/[A-Z-a-z ]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            onChange={() => setNameErr("")}
                          />
                        </Form.Group>
                        <span
                          className="text text-danger "
                          style={{
                            textAlign: "left",
                          }}>
                          {nameErr && nameErr}
                        </span>
                      </Row>

                      <Form.Group className="mb-3" controlId="formGridemail">
                        <Form.Label>
                          Email<span className="red-star">*</span>
                        </Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter Email"
                          id="email"
                          onChange={() => setEmailErr("")}
                        />
                        <span
                          className="text text-danger"
                          style={{
                            textAlign: "left",
                          }}>
                          {emailErr && emailErr}
                        </span>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        className="mb-3"
                        controlId="formGridpassword">
                        <Form.Label>
                          Contact Number<span className="red-star">*</span>
                        </Form.Label>
                        <div className="d-flex">
                          <Form.Select
                            defaultValue="+91"
                            className="code-hoder me-1">
                            <option>+91</option>
                          </Form.Select>
                          <Form.Control
                            type="text"
                            minlength="10"
                            maxlength="10"
                            placeholder="Enter Contact No"
                            className="mobile-holder"
                            id="mobile"
                            onKeyDown={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                if (event.key != "Backspace")
                                  event.preventDefault();
                              }
                            }}
                            onChange={() => setMobileErr("")}></Form.Control>
                        </div>
                        <span
                          className="text text-danger"
                          style={{
                            textAlign: "left",
                          }}>
                          {mobileErr && mobileErr}
                        </span>
                      </Form.Group>

                      <Form.Group className="mb-3" controlId="formGridcity">
                        <Form.Label>
                          Living City<span className="red-star">*</span>
                        </Form.Label>
                        <Select
                          value={selectedOption}
                          onChange={(selectedOption) => {
                            setSelectedOption(selectedOption);
                            setLivingErr("");
                          }}
                          options={cities}
                          isSearchable={true}
                          id="living"
                        />
                        <span
                          className="text text-danger"
                          style={{
                            textAlign: "left",
                          }}>
                          {livingErr && livingErr}
                        </span>
                      </Form.Group>

                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlTextarea1">
                        <Form.Label>Your Message or Query</Form.Label>
                        <Form.Control
                          placeholder="Type here"
                          as="textarea"
                          style={{ height: "100px" }}
                          id="message"
                          onChange={() => setMessageErr("")}
                        />
                        <span
                          className="text text-danger"
                          style={{
                            textAlign: "left",
                          }}>
                          {messageErr && messageErr}
                        </span>
                      </Form.Group>

                      <div className="mb-lg-3 mb-3 text-center">
                        {/* <Link to='/dashboardmain'> */}

                        {/* </Link> */}
                        <div className="d-flex justify-content-center">
                          <Dark_Blue_Btn
                            btn_name="Submit"
                            onClick={handleValidation}
                          />

                          {/* <button
                            type="button"
                            onClick={handleValidation}
                            className="btn  accept-btn "
                          >
                            Submit
                          </button> */}
                          <ContactModal
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                          />
                        </div>
                      </div>
                    </Form>
                  </div>
                  <div className="col-xxl-5 col-xl-5 col-lg-5 p-xxl-0 p-xl-0 p-lg-0 p-md-none">
                    <div className="image-holder">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/Images/contact_us/Jobseeker-login-page2.jpeg"
                        }
                        className="background"
                        alt="..."
                      />
                      <div className="img_overlay"></div>
                      {/* <div className="overlay-holder">
                        <h5>We are </h5>
                        <h6>listening to you! </h6>
                        <p>No matter</p>
                        <p>what query you have</p>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contactus;
